import { c as _c } from "react/compiler-runtime";
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import type { InputProps } from '../internal/input';
import Input from '../internal/input';
import ClearButton from './components/clear-button';
import SearchIcon from './components/search-icon';
type BaseProps = Omit<InputProps, 'disabled' | 'hasError' | 'hint' | 'label' | 'mask' | 'placeholder' | 'type' | 'size' | 'prefixComponent' | 'suffixComponent'>;
export type SearchInputProps = BaseProps & {
  clearButtonAriaLabel?: string;
  onReset?: () => void;
  placeholder?: string;
  size?: 'compact' | 'default';
  /** `pill` matches the filter controls beside a table search (filter pills, the Filters button). */
  shape?: 'default' | 'pill';
};
const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>((t0, ref) => {
  const $ = _c(34);
  let clearButtonAriaLabel;
  let onChange;
  let onChangeText;
  let onReset;
  let placeholder;
  let remainingProps;
  let t1;
  let t2;
  let value;
  if ($[0] !== t0) {
    ({
      clearButtonAriaLabel,
      onChange,
      onChangeText,
      onReset,
      placeholder,
      value,
      size: t1,
      shape: t2,
      ...remainingProps
    } = t0);
    $[0] = t0;
    $[1] = clearButtonAriaLabel;
    $[2] = onChange;
    $[3] = onChangeText;
    $[4] = onReset;
    $[5] = placeholder;
    $[6] = remainingProps;
    $[7] = t1;
    $[8] = t2;
    $[9] = value;
  } else {
    clearButtonAriaLabel = $[1];
    onChange = $[2];
    onChangeText = $[3];
    onReset = $[4];
    placeholder = $[5];
    remainingProps = $[6];
    t1 = $[7];
    t2 = $[8];
    value = $[9];
  }
  const size = t1 === undefined ? "default" : t1;
  const shape = t2 === undefined ? "default" : t2;
  const {
    t
  } = useTranslation("ui");
  let t3;
  if ($[10] !== onChangeText || $[11] !== onReset) {
    t3 = () => {
      onChangeText?.("");
      onReset?.();
    };
    $[10] = onChangeText;
    $[11] = onReset;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const handleClearInput = t3;
  let t4;
  if ($[13] !== clearButtonAriaLabel || $[14] !== handleClearInput || $[15] !== t || $[16] !== value) {
    t4 = () => <ClearButton aria-label={clearButtonAriaLabel ?? t("components.search-input.clear-button-aria-label-default") as string} isVisible={!!value} onClick={handleClearInput} />;
    $[13] = clearButtonAriaLabel;
    $[14] = handleClearInput;
    $[15] = t;
    $[16] = value;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  const renderSuffix = t4;
  let t5;
  if ($[18] !== placeholder || $[19] !== t) {
    t5 = placeholder ?? t("components.search-input.placeholder-default") as string;
    $[18] = placeholder;
    $[19] = t;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SearchIcon />;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== renderSuffix) {
    t7 = renderSuffix();
    $[22] = renderSuffix;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== onChange || $[25] !== onChangeText || $[26] !== ref || $[27] !== remainingProps || $[28] !== shape || $[29] !== size || $[30] !== t5 || $[31] !== t7 || $[32] !== value) {
    t8 = <Input {...remainingProps} onChange={onChange} onChangeText={onChangeText} placeholder={t5} prefixComponent={t6} ref={ref} size={size} data-shape={shape} suffixComponent={t7} value={value} />;
    $[24] = onChange;
    $[25] = onChangeText;
    $[26] = ref;
    $[27] = remainingProps;
    $[28] = shape;
    $[29] = size;
    $[30] = t5;
    $[31] = t7;
    $[32] = value;
    $[33] = t8;
  } else {
    t8 = $[33];
  }
  return t8;
});
export default SearchInput;